import { isEmptyObj } from 'sky-engine/utils'

import { checkOrgName } from '@/api/user'
import lang from '@/lang'
const passwordReg = /^(?=.*[0-9])(?=.*[a-zA-Z])([0-9a-zA-Z_\s]{6,15}$)/
const phoneReg = /^(\s*(1[3-9][0-9])+\d{8})\s*$/
const nameReg = /^[\u4e00-\u9fa5a-zA-Z]+$/
// eslint-disable-next-line no-useless-escape
const realNameReg = /^[\u4e00-\u9fa5a-zA-Z0-9\s+_\(\)\（\）]*$/

const urlReg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\（\）\(\)\u2E80-\u9FFF\\+&%$#=~_-]+))*$/

const FormValidate = {
  name: function(rule, value, callbackk) {},
  email: function(rule, value, callback) {},
  password: function(rule, value, callback) {
    if (isEmptyObj(value)) {
      callback(new Error(lang.t('tips.form.not_empty_pass')))
    } else if (value.length > 15 || value.length < 6) {
      callback(new Error(lang.t('tips.form.verify_pass_len')))
    } else if (!passwordReg.test(value)) {
      callback(new Error(lang.t('tips.form.verify_pass_contain')))
    } else {
      callback()
    }
  },
  phone: function(rule, value, callback) {
    if (isEmptyObj(value)) {
      callback(new Error(lang.t('tips.form.not_empty_phone')))
    } else if (!phoneReg.test(value)) {
      callback(new Error(lang.t('tips.form.verify_phone_contain')))
    } else {
      callback()
    }
  },
  userCode: function(rule, value, callback) {
    if (isEmptyObj(value)) {
      callback(new Error(lang.t('tips.form.not_empty_verify_code')))
    } else {
      callback()
    }
  },
  termService: function(rule, value, callback) {
    if (!value) {
      callback(new Error(lang.t('tips.form.verify_term_service')))
    } else {
      callback()
    }
  },
  userName: function(rule, value, callback) {
    if (value === '') {
      callback()
      return
    }
    if (value.length > 32) {
      callback(new Error(lang.t('tips.form.long32_limit')))
    } else if (!realNameReg.test(value)) {
      callback(new Error(lang.t('tips.form.real_name_limit')))
    } else {
      callback()
    }
  },
  orgName: function(rule, value, callback) {
    if (isEmptyObj(value)) {
      callback(new Error(lang.t('tips.form.not_empty')))
      return
    }
    if (value.length > 64) {
      callback(new Error(lang.t('tips.form.long64_limit')))
    }
    if (!nameReg.test(value)) {
      callback(new Error(lang.t('tips.form.cn_en_limit')))
      return
    }
  },
  orgNameValid: function(rule, value, callback) {
    if (isEmptyObj(value) || !nameReg.test(value)) {
      callback()
      return
    }
    checkOrgName({
      name: value
    })
      .then(response => {
        if (!response.data.content) {
          callback(new Error(lang.t('tips.form.org_name_repeat')))
        } else {
          callback()
        }
      })
      .catch(e => {
        callback()
      })
    callback()
  },
  validateURL: function(rule, value, callback) {
    if (!value.trim()) {
      callback()
    } else if (urlReg.test(value.trim())) {
      callback()
    } else {
      callback(lang.t('sk.form.common_term_url_valid'))
    }
  }
}

// copy from node_modules/@sk/sk-web-ui/lib/sk-ui/lib/form-verify/index.js
const validator = {
  nameReg: /^(\w|[\u4E00-\u9FA5]|-)*$/,
  // emailReg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  // emailReg: /^\w[-\\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\\.)+[A-Za-z]{2,14}$/,
  emailReg: /^\w[-\w.+]*@([A-Za-z0-9][-A-Za-z0-9]+\.)+[A-Za-z]{2,14}$/,
  ipAddrReg: /^(?:(?:1[0-9][0-9]\.)|(?:2[0-4][0-9]\.)|(?:25[0-5]\.)|(?:[1-9][0-9]\.)|(?:[0-9]\.)){3}(?:(?:1[0-9][0-9])|(?:2[0-4][0-9])|(?:25[0-5])|(?:[1-9][0-9])|(?:[0-9]))$/,
  portReg: /^([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  commonNameReg: /^[0-9a-zA-Z\u4e00-\u9fa5.\-@]{1}[0-9a-zA-Z\u4e00-\u9fa5.\-_@]*$/,
  disabledNamed: /^(?!.?(?:admin|special)).*$/,
  integer: /^[-+]?\d+$/,
  number: /^[-\\+]?[0-9]+\.?[0-9]*$/,
  numberSub: /^[-+]?0\d/,
  port: /^([1-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/,
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  spRegexp: /[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
  charAndNumReg: /^(?=.*[0-9])(?=.*[a-zA-Z])(.{8,16})$/
}

export { FormValidate, passwordReg, phoneReg, nameReg, realNameReg, validator, urlReg }
